<div class="bottom-bar d-none d-sm-block">
  <div class="d-flex align-items-center h-100">
    <div class="bottom-bar_actions d-flex">
      <i class="icon-stepback" (click)="back()"></i>
      <i class="icon-stepforward" (click)="forward()"></i>
      <i class="icon-refreshhh" (click)="reload()"></i>
      <i [ngClass]="fullScreenIcon ? 'icon-shrink' : 'icon-fullscreen1'" (click)="toggleFullScreen()"></i>
    </div>
    <div class="bottom-bar_buttons d-flex flex-grow-1 justify-content-end">
      <div class="bottom-bar_buttons_button" *ngIf="showSubmitButton">
        <button siPreventDoubleClick
                class="si-button_main"
                [class.no-active]="!enableButton"
                type="submit"
                [attr.form]="formName"
                (click)="submit()">
          <i *ngIf="!hideSubmitIcon" class='icon-floppydisk'></i>{{ submitButtonText | translate }}
        </button>
      </div>
      <div class="bottom-bar_buttons_button" *ngIf="showSignButton">
        <button siPreventDoubleClick
                class="si-button_main"
                [class.no-active]="!enableButton"
                type="submit"
                [attr.form]="formName"
                (click)="sign()">
          <i class='icon-signature'></i>{{'SI_SIGN' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>
